// src/utils/currentProfile.js
// Helpers to store and retrieve the currently selected kid profile
// so KidHeader doesn't need an extra API call on every page

const KEY = 'wingio_current_profile';

export function setCurrentProfile(profile) {
    if (!profile) return;
    const data = {
        _id: profile._id,
        profile_name: profile.profile_name || '',
        serialNumber: profile.deviceDetail?.serialNumber || '',
        kidProfilePic: profile.deviceDetail?.kidProfilePic || null,
        appVersion: profile.deviceDetail?.appVersion || null,
        wifiConnected: profile.deviceDetail?.wifiConnected || false,
        batteryPercentage: profile.deviceDetail?.batteryPercentage || null,
    };
    try {
        localStorage.setItem(KEY, JSON.stringify(data));
    } catch (e) {
        console.warn('[currentProfile] Failed to save to localStorage:', e);
    }
}

export function getCurrentProfile() {
    try {
        const raw = localStorage.getItem(KEY);
        return raw ? JSON.parse(raw) : null;
    } catch (e) {
        console.warn('[currentProfile] Failed to read from localStorage:', e);
        return null;
    }
}

export function clearCurrentProfile() {
    try {
        localStorage.removeItem(KEY);
    } catch (e) {
        console.warn('[currentProfile] Failed to clear localStorage:', e);
    }
}

export function updateCurrentProfileField(field, value) {
    const profile = getCurrentProfile();
    if (!profile) return;
    profile[field] = value;
    try {
        localStorage.setItem(KEY, JSON.stringify(profile));
    } catch (e) {
        console.warn('[currentProfile] Failed to update field:', e);
    }
}